module.exports = __webpack_public_path__ + "img/allow-msg-request.1b3248fd.jpg";